import { useQueryClient } from '@tanstack/react-query';
import { useGoodsSno } from './useGoodsSno';
import { useCallback, useEffect } from 'react';
import { queryKey } from '../constant/queryKey';
import { goodsService, screensService } from 'shared/src/api';

export const usePreloadQuery = () => {
  const client = useQueryClient();
  const goodsSno = useGoodsSno();

  const preloadQuery = useCallback(() => {
    client.prefetchQuery({
      queryKey: queryKey.relatedGoods(goodsSno),
      queryFn: () => goodsService.getRelatedGoods(goodsSno),
    });
    client.prefetchQuery({
      queryKey: queryKey.goodsOptionsBrief(goodsSno),
      queryFn: () => goodsService.getGoodsOptionsBrief(goodsSno),
    });
    client.prefetchQuery({
      queryKey: queryKey.goodsOptions(goodsSno, { depth: 1 }),
      queryFn: () => {
        return goodsService.getGoodsOptions(goodsSno, { depth: 1 });
      },
    });

    client.prefetchQuery({
      queryKey: queryKey.goodsAtomicComponents(goodsSno),
      queryFn: () =>
        screensService.get({
          screen: 'GOODS_DETAIL',
          goods_sno: goodsSno,
          next_token: null,
        }),
    });
    client.prefetchQuery({
      queryKey: queryKey.goodsMidRelatedRecommend(goodsSno),
      queryFn: () => goodsService.getMidRelatedAdGoods(goodsSno),
    });

    client.prefetchQuery({
      queryKey: queryKey.goodsCodi(goodsSno),
      queryFn: () => goodsService.getCodiGoods(goodsSno),
    });
  }, [client, goodsSno]);

  useEffect(() => {
    preloadQuery();
  }, [preloadQuery]);
};
